module.exports = __webpack_public_path__ + "static/media/bg.7ae59f88.png";